import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { GoogleAnalyticsManager } from "./GoogleAnalyticsManager";

export const CustomerAnalyticsManager = (function(){
	
	class Manager extends GoogleAnalyticsManager {
		constructor(options) {
			options = options || {};
			options.enabled = true;
			options.dimensionMap = {
				'dimension1': 'AdminOrUser',
				'dimension2': 'PACConfig'
			};
			options.variables = {
				'PACConfig': window.config
			};

			super(options);
		}
		setupPersonalListeners() {
			//implement in sub class, throw exception
			TLCLogger.log("setting up personal listeners from SUB class for " + this.googleAnalyticTracker.trackingCode);
			var _this = this;

			TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onClickAvailabilityLink, function (event) {
				if (event.resource.downloadable === true) {
					_this.trackEResourceClick('availability', event.resource.hostBibliographicId, event.resource);
				}
			});
			TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onClickMoreOptionsLink, function (event) {
				_this.trackEResourceClick('moreoptions', event.resource.hostBibliographicId, event.resource);
			});
			TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onClickDownloadLink, function (event) {
				_this.trackEResourceClick('download', event.resource.hostBibliographicId, event.resource);
			});
		}
	}
	
	
	//public functions
	var instance, publicFunctions = {
		getTrackingCode: function(){
			return instance.googleAnalyticTracker.trackingCode;
		},
		getEnabled: function(){
			return instance.googleAnalyticTracker.enabled;
		},
		getGoogleAnalyticsTracker: function(){
			return this.googleAnalyticTracker;
		}
	};
	
	var _static = {
		getInstance: function(options){
			if (instance === undefined) {
				instance = new Manager(options);
			}
			return publicFunctions;
		}
	};
	return _static;
})();
